/*
  One marquee for every band on the site.  (Igor 2026-09-08)

  Igor asked three times for the bands to run non-stop. I fixed ONE of them
  (the "Homies in the wild" video grid) and left two others still running
  Swiper with arrows and pause controls: the product-page video band
  (ss-product-videos-5) and the review band (ss-testimonials-39, which appears
  on both the homepage and the product page). Hence "still not like i asked".

  Rather than hand-edit each section, this converts any of them uniformly:

    - tear down Swiper if it already booted (it sets its own transform, which
      would fight the animation)
    - duplicate the slides once so the loop seam is invisible
    - hand the track to a CSS animation that never stops

  Swiper's own loop+autoplay stalls at the loop boundary no matter the speed,
  which is the stop-start Igor kept seeing. A CSS translate cannot stall.
*/
(function () {
  'use strict';

  var TRACK_SELECTORS = [
    '[class*="video-social-slider-"]',
    '[class*="video-slider-"]',
    '[class*="testimonials-slider-"]'
  ];

  // seconds per slide; keeps the speed constant however many clips exist
  var SECONDS_PER_SLIDE = 7;

  function convert(root) {
    if (!root || root.dataset.hmMarquee === 'on') return;

    var wrapper = root.querySelector('.swiper-wrapper');
    if (!wrapper) return;

    var slides = Array.prototype.slice.call(wrapper.children);
    if (slides.length < 2) return;

    // Swiper owns the transform until it is destroyed
    if (root.swiper && typeof root.swiper.destroy === 'function') {
      try { root.swiper.destroy(true, true); } catch (e) {}
    }
    root.classList.remove('preview');
    root.dataset.hmMarquee = 'on';

    // second copy, hidden from assistive tech so nothing is announced twice
    slides.forEach(function (s) {
      var clone = s.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      clone.removeAttribute('id');
      wrapper.appendChild(clone);
    });

    wrapper.classList.add('hm-marquee-track');
    wrapper.style.setProperty('--hm-marquee-duration', (slides.length * SECONDS_PER_SLIDE) + 's');

    // the controls drive a Swiper that no longer exists
    root.parentElement && Array.prototype.forEach.call(
      root.parentElement.querySelectorAll('[class*="btn-prev"], [class*="btn-next"]'),
      function (b) { b.classList.add('hm-marquee-hide'); }
    );
    Array.prototype.forEach.call(
      root.querySelectorAll('[class*="-action-"], [class*="pause"]'),
      function (b) { b.classList.add('hm-marquee-hide'); }
    );

    /*
      Videos in a band play ONLY while they are actually on screen.

      MEASURED 2026-09-13, and this was the worst defect on the site: calling
      play() on every clip made the homepage a 98.1 MB download (24 video
      requests, 50 <video> tags, 48 playing at once) and the product page
      29.4 MB. Every one of those tags already carried preload="none" - a
      play() call OVERRIDES it and starts the fetch immediately. So the
      attribute was never the problem; this loop was.

      An IntersectionObserver keeps the marquee looking identical (the clips a
      visitor can see are moving) while the ones off screen never download.
      The track is CSS-transformed, which IO handles correctly because it reads
      rendered geometry, and slides are duplicated for the seam so roughly half
      the tags are off screen at any moment by construction.
    */
    var vids = root.querySelectorAll('video');
    Array.prototype.forEach.call(vids, function (v) {
      v.muted = true; v.loop = true; v.controls = false;
      v.setAttribute('playsinline', '');
      v.setAttribute('preload', 'none');
      /*
        STRIP AUTOPLAY. This is the half of the 98 MB bug the first fix missed.
        In Chrome an `autoplay muted` video starts buffering REGARDLESS of
        preload="none", because the browser has to have data in order to
        autoplay. Removing the play() calls stopped the JS from downloading
        them; the attribute kept the BROWSER doing it.

        Measured on the deployed preview at 390px before this line existed:
        49 video tags on the homepage, none in view, none playing, 14.6 MB of
        mp4 still transferred.

        The property has to go too. Setting the attribute away does not clear
        the IDL property on an element the parser already created.
      */
      v.removeAttribute('autoplay');
      v.autoplay = false;
      /*
        Lazy clips carry data-src until the section's LazyLoad reaches them. The
        clones made above are never registered with it, so they stayed as empty
        boxes with a play icon in the band (Igor 2026-09-26, live). Promote the
        source here: preload is none, so nothing downloads until the observer
        below plays a clip that is actually on screen.
      */
      var lazySrc = v.getAttribute('data-src');
      if (lazySrc && !v.getAttribute('src')) {
        v.setAttribute('src', lazySrc);
        v.removeAttribute('data-src');
        v.classList.remove('lazy');
      }
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        Array.prototype.forEach.call(entries, function (e) {
          var v = e.target;
          if (e.isIntersecting) {
            if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
          } else if (!v.paused) {
            v.pause();
          }
        });
      }, { threshold: 0.25 });
      Array.prototype.forEach.call(vids, function (v) { io.observe(v); });
    } else {
      // No IO: play the first few rather than all of them. Never all of them.
      Array.prototype.forEach.call(vids, function (v, i) {
        if (i > 2) return;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
      });
    }
  }

  function run() {
    TRACK_SELECTORS.forEach(function (sel) {
      Array.prototype.forEach.call(document.querySelectorAll(sel), convert);
    });
  }

  function start() {
    run();
    // sections boot their sliders on their own schedule, so sweep a few times
    [300, 900, 2000, 4000].forEach(function (t) { setTimeout(run, t); });
    document.addEventListener('shopify:section:load', function () { setTimeout(run, 200); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
